module.exports = __webpack_public_path__ + "static/media/transaction-pending-icon-orange.a77aba2e.svg";